/* global FileReader*/
/**
 * Take a image string on format path/name.ext and transform to the
 * correct path accordly to the selected type path/name_size.ext
 *
 * Posible types are
 *  thumbnail, small, square, large
 *
 * usage
 * <img em-src-image="'assets/articles/99999/xewxhgpw.png'", thumbnail/>
 */
(function() {
    'use strict';
    var sizes = {
        thumbnail: '64x64',
        small: '240x144',
        square: '350x350',
        large: '840x504'
    };
    angular.module('emarket.commons').directive('emSrcImage', ['$log', 'PATH', function($log, PATH) {
        return {
            scope: {
                emSrcImage: '='
            },
            link: function(scope, element, attr) {
                var size;
                var event = scope.$watch('emSrcImage', function() {
                    Object.keys(attr).some(function(key) {
                        if (sizes[key] !== undefined) {
                            size = sizes[key];
                            return true;
                        }
                    });
                    if (!size) {
                        throw new Error('You must past a least one of the different sizes types [thumbnail, small, square, large] on emSrcImage');
                    }
                    var image = PATH.server + '/assets/noimagefound.jpg';
                    var regex = /\.(\w{3}|\w{4})$/;
                    if (scope.emSrcImage && scope.emSrcImage.path) {
                        if (typeof scope.emSrcImage !== 'string') {
                            //get the ext
                            var match = scope.emSrcImage.path.match(regex);
                            if (match) {
                                var ext = match[0];
                                image = scope.emSrcImage.path.replace(regex, '_' + size) + ext;
                                image = PATH.server + '/' + image;
                            }
                        } else {
                            image = scope.emSrcImage;
                        }
                    }
                    if (scope.emSrcImage && scope.emSrcImage.lastModified) {
                        // is a File type
                        $log.info(scope.emSrcImage);
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            element.attr('src', e.target.result);
                        };
                        reader.readAsDataURL(scope.emSrcImage);
                    } else {
                        element.attr('src', image);
                    }
                });
                scope.$on('$destroy', function() {
                    event();
                });
            }
        };
    }]);
}());
